import { InjectionToken } from '@angular/core';
import { MenuConfigOptions } from '../model/menu-config-options.model';
export const MENU_CONFIG_OPTIONS = new InjectionToken<MenuConfigOptions>('MENU_CONFIG_OPTIONS');
